<template>
<span class="Polaris-VisuallyHidden">
    <slot></slot>
</span>
</template>

<script>
export default {
}
</script>


// WEBPACK FOOTER //
// src/components/PolarisVisuallyHidden.vue?170e6477